import { useState } from 'react';

/**
 * When the current turn started: set in the same render the chat starts responding,
 * so every block that times the turn reads one clock from the first frame.
 */
export const useTurnStartedAt = (responding: boolean): number | undefined => {
  const [startedAt, setStartedAt] = useState<number>();
  const [wasResponding, setWasResponding] = useState(responding);

  if (responding !== wasResponding) {
    setWasResponding(responding);
    if (responding) setStartedAt(Date.now());
  }

  return startedAt;
};
